import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgOs = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.333 12c.734 0 1.327-.6 1.327-1.333L14.667 4c0-.733-.6-1.333-1.334-1.333H2.667c-.734 0-1.334.6-1.334 1.333v6.667c0 .733.6 1.333 1.334 1.333H0v1.333h16V12h-2.667zM2.667 4h10.666v6.667H2.667V4z",
		fillRule: "nonzero"
	})
});
export default SvgOs;
